/**
 * Availability Indicator Component (Icon-Only)
 * Shows real-time availability status as icon inside input field
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AvailabilityStatus } from '../../utils/availability.utils';

interface AvailabilityIndicatorProps {
  status: AvailabilityStatus | null;
  field: 'username' | 'email';
  value: string;
}

export const AvailabilityIndicator: React.FC<AvailabilityIndicatorProps> = ({
  status,
  field,
  value,
}) => {
  // Don't show anything if no value or too short
  if (!value || (field === 'username' && value.length < 3) || (field === 'email' && !value.includes('@'))) {
    return null;
  }

  const getIcon = () => {
    switch (status) {
      case 'checking':
        return (
          <FontAwesomeIcon 
            icon={faSpinner} 
            className="w-4 h-4 text-blue-600 animate-spin" 
            title="Memeriksa ketersediaan..."
          />
        );

      case 'available':
        return (
          <FontAwesomeIcon 
            icon={faCheck} 
            className="w-4 h-4 text-green-600" 
            title={field === 'username' ? 'Username tersedia' : 'Email tersedia'}
          />
        );

      case 'taken':
        return (
          <FontAwesomeIcon 
            icon={faTimes} 
            className="w-4 h-4 text-red-600" 
            title={field === 'username' ? 'Username sudah digunakan' : 'Email sudah terdaftar (termasuk variasi Gmail dengan titik)'}
          />
        );

      case 'error':
        return null; // Don't show error icon to avoid confusion

      default:
        return null;
    }
  };

  return (
    <div className="absolute right-3 top-1/2 -translate-y-1/2 z-10">
      {getIcon()}
    </div>
  );
};